<div id="uploaders-list">
  <iframe [src]="iframeUrl"></iframe>
</div>
